import * as React from "react"
import List, { ListTypeMap } from "@mui/material/List"
import { styled, Theme } from "@mui/material/styles"
import { meshBgNavImageUri } from "../../styles/BackgroundStyles"
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import Select, { SelectProps } from "@mui/material/Select"

function getBackgroundStyles(theme: Theme) {
  switch (theme.themeName) {
    case "Fabriq":
      return {
        background: `rgb(59, 64, 76) ${meshBgNavImageUri} left bottom / cover no-repeat`,
        backgroundSize: "400px 400px"
      }
    default:
      return {
        background: theme.palette.background.default
      }
  }
}

export const NavTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.popper}`]: {
    marginLeft: -10,
    position: "relative"
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgb(59, 64, 76)"
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(59, 64, 76)",
    padding: "0.5rem"
    
  }
}))

export const AppSwitcher = styled(Select)<SelectProps>(({ theme }) => {
  return {
    "&.MuiInputBase-root": {
      width: "auto"
    },
    ".MuiCollapse-entered &.MuiInputBase-root": {
      width: "100%"
    },
    "& .MuiSelect-select": {
      whiteSpace: "nowrap",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      background: "rgb(255 255 255 / 0%)",
      border: "none",
      color: "white",
      padding: "0.25rem !important"
    },
    ".MuiCollapse-entered & .MuiSelect-select": {
      padding: "0.25rem",
      background: "rgb(255 255 255 / 10%)"
    },
    "& .MuiSelect-icon": {
      opacity: 0,
      transition: "opacity .4s .2s",
      color: "white"
    },
    "& .MuiAvatar-root": {
      width: 32,
      height: 32
    },
    ".MuiCollapse-entered & .MuiAvatar-root": {
      marginRight: "0.5rem"
    },
    
    ".MuiCollapse-entered & .MuiSelect-icon": {
      opacity: 1
    },
    "& span": {
      display: "none",
      padding: "0.25rem",
      fontSize: "0.875rem",
      color: "white",
      fontWeight: 600
    },
    ".MuiCollapse-entered & span": {
      display: "inline",
      padding: "0.25rem 0.5rem 0.25rem 0.25rem"
    }
  }
})

export const NestedNavList = styled(List)<ListTypeMap>(({ theme }) => {
  return {
    marginLeft: "2rem",
    paddingLeft: "1rem",
    borderLeft: "1px solid rgba(189, 191, 191, 0.3)",
    borderImage:
      "linear-gradient(0deg, transparent 20px, rgba(189, 191, 191, 0.3) 20px) 2 / 2px",
    borderImageWidth: "0 0 0 2px"
  }
})

export const NavList = styled(List)<ListTypeMap>(({ theme }) => {
  const textColor = "white"
  return {
    width: 300,
    color: textColor,
    padding: "0.25rem 0.75rem",
    ...getBackgroundStyles(theme),
    "& .MuiListSubheader-root": {
      fontSize: "0.875rem",
      color: textColor,
      fontWeight: 600
    },
    "& .MuiListItemButton-root": {
      height: "3rem",
      marginTop: "0.25rem",
      marginBottom: "0.25rem",
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem",
      borderRadius: 5,
      transition: "background .6s ease",
      "&:hover": {
        background: "rgba(242, 242, 243, 0.1)"
      },
      ":not(.MuiCollapse-entered &)": {
        width: "2.5rem",
        overflow: "hidden"
      }
    },
    "& .MuiDivider-root": {
      margin: "1rem 0.25rem",
      borderColor: "rgba(189, 191, 191, 0.3)",
      transition: "width 1s .4s ease",
      ":not(.MuiCollapse-entered &)": {
        width: "2rem"
      }
    },
    "& .MuiListItemButton-root, & .MuiListSubheader-root": {
      "&.Mui-selected": {
        background: theme.colorScales.primary(1).alpha(0.1).css(),
        color: theme.colorScales.primary(1).css()
      },
      "& .MuiListItemText-root .MuiTypography-root": {
        fontSize: "0.875rem",
        color: textColor,
        fontWeight: 600,
        opacity: 0,
        transition: "opacity .4s ease",
        ".MuiCollapse-entered &": {
          opacity: 1
        }
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        width: 24,
        minWidth: 24,
        height: 24,
        color: textColor,
        marginRight: "1rem"
      },
      "&.Mui-selected > .MuiListItemText-root > .MuiTypography-root": {
        color: theme.colorScales.primary(1).css()
      },
      "&.Mui-selected > .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: theme.colorScales.primary(1).css()
      },
      "& .MuiListItemButton-root": {
        "&:hover": {
          background: "rgba(77, 82, 93)"
        }
      }
    }
  }
})
